import { types } from "../Actions/types";

const initialState = {
  activeUsers: {
    male: {
      dates: [],
      recordcounts: []
    },
    female: {
      dates: [],
      recordcounts: []
    },
    total: {
      dates: [],
      recordcounts: []
    },
    uniqueActiveUsers: {
      male: 0,
      female: 0
    }
  },
  registeredUsers: { dates: [], recordcounts: [] },
  workOutSessions: { dates: [], recordcounts: [] },
  avgWorkOutSessions: { dates: [], recordcounts: [] }
};

export const dashBoardReportReducer = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.DASHBOARD_REPORTS_ACTIVE_USERS:
      return {
        ...state,
        activeUsers: payload,
        error,
      };
    case types.DASHBOARD_REPORTS_REGISTERED_USERS:
      return {
        ...state,
        // registeredUsers: payload,
        registeredUsers: { ...state.registeredUsers, ...(payload || {}) },

        error,
      };
    case types.DASHBOARD_REPORTS_WORKOUT_SESSIONS:
      return {
        ...state,
        workOutSessions: payload.workouts,
        avgWorkOutSessions: payload.duration,
        error,
      };
    case types.DASHBOARD_REPORTS_AVG_WORKOUT_SESSIONS:
      return {
        ...state,
        avgWorkOutSessions: payload,
        error
      };

    default:
      return state;
  }
};
